import React from 'react';
import { motion } from 'framer-motion';
import { ResizeHandle } from '../types/room';
interface ElementResizeHandlesProps {
  x: number;
  y: number;
  width: number;
  height: number;
  centerX: number;
  centerY: number;
  rotation?: number;
  onResizeStart: (handle: ResizeHandle, e: React.MouseEvent) => void;
  showCorners?: boolean;
}
export function ElementResizeHandles({
  x,
  y,
  width,
  height,
  centerX,
  centerY,
  rotation = 0,
  onResizeStart,
  showCorners = true
}: ElementResizeHandlesProps) {
  const handles: Array<{
    type: ResizeHandle;
    x: number;
    y: number;
    cursor: string;
  }> = [
  // Edge handles
  {
    type: 'n',
    x: x + width / 2,
    y: y,
    cursor: 'ns-resize'
  }, {
    type: 's',
    x: x + width / 2,
    y: y + height,
    cursor: 'ns-resize'
  }, {
    type: 'e',
    x: x + width,
    y: y + height / 2,
    cursor: 'ew-resize'
  }, {
    type: 'w',
    x: x,
    y: y + height / 2,
    cursor: 'ew-resize'
  }];
  // Add corner handles if enabled
  if (showCorners) {
    handles.push({
      type: 'ne',
      x: x + width,
      y: y,
      cursor: 'nesw-resize'
    }, {
      type: 'nw',
      x: x,
      y: y,
      cursor: 'nwse-resize'
    }, {
      type: 'se',
      x: x + width,
      y: y + height,
      cursor: 'nwse-resize'
    }, {
      type: 'sw',
      x: x,
      y: y + height,
      cursor: 'nesw-resize'
    });
  }
  return <g data-id="element-403">
      {handles.map(handle => <motion.g key={handle.type} initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} data-id="element-404">
          <circle cx={handle.x + centerX} cy={handle.y + centerY} r={6} fill="#4FC3F7" stroke="white" strokeWidth={1.5} className="cursor-pointer" style={{
        cursor: handle.cursor
      }} onMouseDown={e => {
        e.stopPropagation();
        onResizeStart(handle.type, e);
      }} data-id="element-405" />
        </motion.g>)}
    </g>;
}